import { ProOrganizerRequestEntity } from "../../domains/pro-organizer-request-data";

export class FindProOrganizerRequestByUser {
    static readonly type = '[ProOrganizerRequestByUser] Find By User';
}
export class FindProOrganizerRequestByUserSuccess {
    static readonly type = '[ProOrganizerRequestByUser] Find By User Success';
    constructor(public readonly data: ProOrganizerRequestEntity[]) {}
}

export class FindProOrganizerRequestByUserFailure {
    static readonly type = '[ProOrganizerRequestByUser] Find By User Failure';
    constructor(public readonly error: unknown) {}
}